import { colors, fonts } from 'shared/defaultTheme';
import styled from 'styled-components';

const AttachmentBoxWrapper = styled.div`
  box-sizing: border-box;
  height: 34px;
  width: 200px;
  border: 1px solid ${colors.gullGrey};
  border-radius: 1px;
  background-color: ${colors.whiteSmoke};
  display: flex;
  justify-content: space-between;
  align-items: center;
  .chip-name-container {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-left: 4px;
    display: flex;
    align-items: center;
    svg {
      fill: ${colors.black};
    }
    .chip-name {
      color: ${colors.dimGray};
      font-family: ${fonts.roboto};
      font-size: 13px;
      letter-spacing: 0;
      line-height: 40px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .button-icon {
    svg {
      height: 15px;
      width: 15px;
      fill: ${colors.black};
    }
  }
`;

export { AttachmentBoxWrapper };
